import { render, staticRenderFns } from "./MarcasAutos.vue?vue&type=template&id=1f0020a4&scoped=true&"
import script from "./MarcasAutos.vue?vue&type=script&lang=js&"
export * from "./MarcasAutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0020a4",
  null
  
)

export default component.exports